if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      // Get the active media element
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      if (!activeMedia) return; // Safety check
      
      // Remove active class from all media items
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      
      // Add active class to the current media
      activeMedia.classList.add('is-active');

      // Handle prepending (moving to first position)
      if (prepend) {
        // Move the active media to the first position in the slider
        activeMedia.parentElement.prepend(activeMedia);
        
        // Also move the corresponding thumbnail
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          if (activeThumbnail) {
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
        }
        
        // Reset slider pagination if needed
        if (this.elements.viewer.slider) {
          this.elements.viewer.resetPages();
          
          // Force slider to show the first item
          if (this.elements.viewer.slider.sliderItems && this.elements.viewer.slider.sliderItems.length) {
            // Ensure we're on the first page/slide
            this.elements.viewer.slider.slideScrollPosition = 0;
            this.elements.viewer.slider.translate = 0;
            
            // Update the slider's visual state
            if (this.elements.viewer.slider.sliderItems[0]) {
              this.elements.viewer.slider.sliderItems[0].scrollIntoView({ behavior: 'auto', block: 'nearest' });
            }
          }
        }
      }

      // Prevent header issues
      this.preventStickyHeader();
      
      // Handle scrolling with a delay to ensure DOM updates are complete
      window.setTimeout(() => {
        // Scroll the parent to show this media item
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
        }
        
        // Special handling for different layouts
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
        
        // For mobile, ensure we're showing the correct slide
        const isMobile = window.innerWidth < 750;
        if (isMobile) {
          // Force the slider to position correctly
          if (this.elements.viewer.slider && activeMedia) {
            const index = Array.from(this.elements.viewer.slider.sliderItems).indexOf(activeMedia);
            if (index >= 0) {
              this.elements.viewer.slider.onScrollTo(index);
            }
          }
        }
      }, 50); // Slightly longer timeout to ensure DOM updates are complete
      
      // Handle media playback
      this.playActiveMedia(activeMedia);

      // Update thumbnails
      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      if (activeThumbnail) {
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
